export default {
    pushNotifications : [
    {name:""},
    {title:""},
    {body:""},
    {urltext: ""}
    ],
    getAllRegisteredUser : [],
    members : [],
    campaignReports : [],
    apiReports : [],
    
}